import { render } from "./LocallyLocator.vue?vue&type=template&id=525b429b"
import script from "./LocallyLocator.vue?vue&type=script&lang=js"
export * from "./LocallyLocator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__